import { Modal, Logo } from '@insight-health-ai/roseate/components';
import { useAuthStore } from 'src/hooks/auth';
import { useChatValidationStore } from 'src/hooks/chat';
import { analytics } from 'src/services/analytics';
import { getAppointmentDetailsForAnalytics } from 'src/utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CompletionScreen = ({ isOpen }: { isOpen: boolean }) => {
  const { t } = useTranslation('vca', { keyPrefix: 'chatCompletion' });

  const { logout, appointment } = useAuthStore();
  const { token } = useChatValidationStore();
  const navigate = useNavigate();
  const handleLogout = async () => {
    analytics.track(
      'Clicked Logout',
      getAppointmentDetailsForAnalytics(appointment!)
    );
    await logout({ chatToken: token! });

    navigate('/logout');
  };

  return (
    <Modal
      closable={false}
      open={isOpen}
      primaryAction={{
        onClick: () => {
          handleLogout();
        },
        size: 'lg',
        block: true,
        content: t('logoutButton'),
      }}
      title={
        <div className="flex flex-col items-center pb-[20px]">
          <Logo className="h-8" />
        </div>
      }
    >
      <div className="text-center color-primary text-lg">
        {t('chat.successMessage')}
      </div>
    </Modal>
  );
};

export { CompletionScreen };
